import HomeLayout from '../layouts/HomeLayout';
import MyProjectsView from '../views/MyProjectsView';
import NewFarm from '../components/farm/NewFarm';
import { MyProjectsQuery } from '../queries';
import SharedProjectsView from '../views/SharedProjectsView';
import UserSettingsView from '../views/UserSettingsView';

const MY_PROJECTS_ROUTE = {
  name: 'My Projects',
  path: 'my-projects',
  children: [
    { index: true, element: <MyProjectsView /> },
    {
      path: 'new',
      element: <NewFarm refetchQuery={MyProjectsQuery} />,
    },
  ],
};

const SHARED_PROJECTS_ROUTE = {
  name: 'Shared with Me',
  path: 'shared-projects',
  element: <SharedProjectsView />,
};

export const HOME_ROUTES = [MY_PROJECTS_ROUTE, SHARED_PROJECTS_ROUTE];

const HomeRoutes = {
  element: <HomeLayout />,
  children: [
    ...HOME_ROUTES,
    {
      path: 'account',
      element: <UserSettingsView />,
    },
  ],
};

export default HomeRoutes;
